import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    Handler,
} from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { CatalogPage } from "@insite/client-framework/Services/CategoryService";
import {
    GetProductCollectionApiV2Parameter,
    ProductExpandTokens,
} from "@insite/client-framework/Services/ProductServiceV2";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, DispatchBeginLoadProducts, PrepageProductRecs } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import cloneDeep from "lodash/cloneDeep";



interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
    relevancy?: boolean;
}

export interface DisplayProductsResult {
    products?: ProductModel[];
    productInfosByProductId: SafeDictionary<ProductInfo>;
    productFilters: ProductFilters;
    isFiltered: boolean;
    unfilteredApiParameter?: GetProductCollectionApiV2Parameter;
    filteredApiParameter?: GetProductCollectionApiV2Parameter;
    catalogPage?: CatalogPage;
}
interface Props {
    apiParameter: GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductExpandTokens;
}
type HandlerType = Handler<Parameter, Props>;

let globalCurrentFilter: ProductFilters = {};

export const CustomDispatchBeginLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Pages/ProductList/BeginLoadProducts",
    });
    globalCurrentFilter = cloneDeep(props.getState().pages.productList.productFilters);

};
export const DispatchSetProductFiltersUpdated: HandlerType = props => {
    const state = props.getState();
    function checkDataInFilterQuery(data: ProductFilters, filterQuery?: string): boolean {
        const urlParams = new URLSearchParams(filterQuery);

        const priceFiltersMatch = data?.priceFilters === undefined || data?.priceFilters?.toString() === urlParams.get('priceFilters');
        const categoryIdMatch = data?.categoryId === undefined || data?.categoryId === urlParams.get('categoryId');

        const productLineIdsMatch = (data?.productLineIds ?? []).every((id: string) => {
            return urlParams.get('productLineIds')?.split(',').includes(id);
        });

        const brandIdsMatch = (data?.brandIds ?? []).every((id: string) => {
            return urlParams.get('brandIds')?.split(',').includes(id);
        });

        const sortMatch = data?.sort === undefined || data.sort === urlParams.get('sort');

        const stockedItemsOnlyMatch = data?.stockedItemsOnly === undefined || data.stockedItemsOnly.toString() === urlParams.get('stockedItemsOnly');

        const attributeValueIdsMatch = (data?.attributeValueIds ?? []).every((id: string) => {
            return urlParams.get('attributeValueIds')?.split(',').includes(id);
        });

        const minimumPriceMatch = (data as any)?.minimumPrice === undefined || (data as any)?.minimumPrice === urlParams.get('minimumPrice');

        return (
            priceFiltersMatch && categoryIdMatch &&
            productLineIdsMatch &&
            brandIdsMatch &&
            attributeValueIdsMatch &&
            minimumPriceMatch && stockedItemsOnlyMatch && sortMatch
        );
    }

    const result = checkDataInFilterQuery(globalCurrentFilter, state.pages.productList.filterQuery);
    globalCurrentFilter.sort  = props.result.productFilters.sort;  
    if (!result && getLocation(state).search === `?${state.pages.productList.filterQuery}`) {
        props.dispatch({
            type: "Pages/ProductList/SetProductFilters",
            result: globalCurrentFilter,
        });
    }else if ((getLocation(state).search !== `?query=${state.pages.productList.productFilters.query}` && getLocation(state).search.replace('?', '') !== state.pages.productList.filterQuery) || getLocation(state).search === `?query=${state.pages.productList.productFilters.query}` ) {
            if (state.pages.productList.filterQuery) {
                props.dispatch({
                    type: "Pages/ProductList/SetFilterQuery",
                    result: getLocation(state).search.replace('?', ''),
                });
            }
        }


};

replaceInChain(chain, DispatchBeginLoadProducts, CustomDispatchBeginLoadProducts);
addToChainAfter(chain, PrepageProductRecs, DispatchSetProductFiltersUpdated);